import React, { useState } from 'react';
import logo from './logo.svg';
import './App.css';
import AppContents from './components/appContents';
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";


function App (){
  const [authenticated, isAuthenticated] = useState(false);
  const [wrongPw, setWrongPw] = useState(false);
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");

//what I was using before
  let realpw = "roblox69";

  const handleAuth = () =>{
    const auth = getAuth();
    signInWithEmailAndPassword(auth, email, pw)
    .then((userCredential) => {
      // Signed in 
      const user = userCredential.user;
      isAuthenticated(true);
      setWrongPw(false);


      // ...
    })
    .catch((error) => {
      const errorCode = error.code;
      const errorMessage = error.message;
      setWrongPw(true);

    });
  }
  
  if (!authenticated){
    return(
      <div>
        <form>
          <label for="email">Email</label><br></br>
          <input  onChange={(e) => setEmail(e.target.value)} type="text" id="email" name="email"></input><br></br>

          <label for="pw">Password</label><br></br>
          <input  onChange={(e) => setPw(e.target.value)} type="text" id="pw" name="pw"></input><br></br>
        </form> 

      <button onClick={()=>handleAuth()}>Submit</button>
      <p style={{ display: wrongPw ? 'block' : 'none' }}>Wrong password!</p>
      </div>
      
    );
   
  }
  else {
    return(
      <AppContents/>
    );
  }
  
}

export default App;
